"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = { "build_version": "2.23.0", "build_date": "2020-10-30T09:43:40.971Z", "build_branch": "2.23.0", "build_commit": "8141f1a050c8d6207daa69b5ecba13e064acdbb1" };
